/* Corsica Blog — responsive hero video (Corsica-specific). Bottom gallery uses native scroll/grid. */
(function () {
  function initCorsica(root) {
    if (!root || root.dataset.corsicaInit === '1') return;
    root.dataset.corsicaInit = '1';

    var hero = root.querySelector('[data-corsica-hero]');
    if (hero) {
      var video = hero.querySelector('.corsica-blog__hero-video');
      var mq = window.matchMedia('(max-width: 768px)');
      var currentMode = null;

      var applySource = function () {
        var isMobile = mq.matches;
        var mode = isMobile ? 'mobile' : 'desktop';
        if (mode === currentMode) return;
        currentMode = mode;
        hero.setAttribute('data-mode', mode);
        if (!video) return;

        var w = window.innerWidth || document.documentElement.clientWidth;
        var src;
        if (isMobile) {
          src = hero.getAttribute('data-mobile-src-sd') || hero.getAttribute('data-mobile-src');
        } else {
          src = (w >= 769) ? hero.getAttribute('data-desktop-src') : hero.getAttribute('data-desktop-src-sd');
        }
        if (!src) return;

        video.setAttribute('muted', '');
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.src = src;
        try { video.load(); } catch (e) {}
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      };

      applySource();
      if (mq.addEventListener) { mq.addEventListener('change', applySource); }
      else if (mq.addListener) { mq.addListener(applySource); }
    }
    /* Bottom gallery uses native horizontal scroll / CSS grid — no JS controls. */
  }

  function boot() {
    var nodes = document.querySelectorAll('.corsica-blog');
    for (var i = 0; i < nodes.length; i++) { initCorsica(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
